<bz-loading *ngIf="showLoading">
</bz-loading>

<div class="select-category" *ngIf="!showLoading">
    <div class="select-category__select">
        <span class="select-category__select-label">{{ 'BASEKNOWLEDGECATALOG.CATEGORY' | translate }}</span>
        <bzg-select placeholder="Select category" [(value)]="selectedCategory"
            (valueChange)="onCategoryChange($event)">
            <bzg-option [value]="allCategory">{{ 'BASEKNOWLEDGECATALOG.ALL' | translate }}</bzg-option>
            <bzg-option *ngFor="let category of categoryList" [value]="category">
                {{ category.DisplayName }}</bzg-option>
        </bzg-select>
    </div>
    <bzg-search class="select-category__search" [placeholder]="'BASEKNOWLEDGECATALOG.SEARCH' | translate" (valueChange)="onSearch($event)"
        [fieldText]="inputSearch" (keydown.enter)="onEnterSearch()"></bzg-search>
</div>

<div *ngIf="!showLoading" class="custom-tabs">
    <div class="tab-header">
        <div *ngIf="showFiles"
            class="tab-button"
            [class.active]="getTabIndex('files') === selectedTab"
            (click)="selectTab(getTabIndex('files'))">
            <bzg-icon [nameIcon]="'icon-knowledge-static'" [size]="16" class="tab-icon"></bzg-icon>
            <span>{{ 'BASEKNOWLEDGECATALOG.STATIC' | translate | uppercase }}</span>
        </div>
        <div *ngIf="showLearned"
            class="tab-button" 
            [class.active]="getTabIndex('learned') === selectedTab"
            (click)="selectTab(getTabIndex('learned'))">
            <bzg-icon [nameIcon]="'icon-knowledge-learned'" [size]="16" class="tab-icon"></bzg-icon>
            <span>{{ 'BASEKNOWLEDGECATALOG.BIZAGI_DATA' | translate | uppercase }}</span>
        </div>
    </div>
    
    <div class="tab-content">
        <div *ngIf="getTabIndex('files') === selectedTab && showFiles" class="tab-panel">
            <biz-base-knowledge-catalog-static 
                [selectedCategory]="selectedCategory"
                [filteredCategoryList]="filteredCategoryList"
                (reloadCatalogs)="reloadCatalogs($event)">
            </biz-base-knowledge-catalog-static>
        </div>
        <div *ngIf="getTabIndex('learned') === selectedTab && showLearned" class="tab-panel">
            <biz-base-knowledge-catalog-learned
                [selectedCategory]="selectedCategory"
                [filteredCategoryListLearned]="filteredCategoryListLearned"
                (refreshKBLearnedOutput)="refreshKBLearned($event)"></biz-base-knowledge-catalog-learned>
        </div>
    </div>
</div>